"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToThreeObject = exports.threeToQuat = exports.toThreeQuaternion = exports.threeToVector3 = exports.toThreeVector3 = exports.threeToVector2 = exports.toThreeVector2 = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
/**
 * Creates a THREE Vector2 from a vector 2
 */
function toThreeVector2(v) {
    return new realms_three_1.default.Vector2(v.x, v.y);
}
exports.toThreeVector2 = toThreeVector2;
/**
 * Converts a three vector 2 to a vector 2
 */
function threeToVector2(v) {
    return {
        x: v.x,
        y: v.y,
    };
}
exports.threeToVector2 = threeToVector2;
/**
 * Converts a vector3 to a THREE Vector3
 */
function toThreeVector3(v) {
    return new realms_three_1.default.Vector3(v.x, v.y, v.z);
}
exports.toThreeVector3 = toThreeVector3;
function threeToVector3(v) {
    return {
        x: v.x,
        y: v.y,
        z: v.z,
    };
}
exports.threeToVector3 = threeToVector3;
function toThreeQuaternion(q) {
    return new realms_three_1.default.Quaternion(q.x, q.y, q.z, q.w);
}
exports.toThreeQuaternion = toThreeQuaternion;
function threeToQuat(q) {
    return {
        x: q.x,
        y: q.y,
        z: q.z,
        w: q.w,
    };
}
exports.threeToQuat = threeToQuat;
// Transforms an object that contains Vector3 and Quat to their three js counterpart
function transformToThreeObject(state) {
    var e_1, _a;
    var out = {};
    try {
        for (var _b = __values(Object.entries(state)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
            if (typeof v.x === "number" &&
                typeof v.y === "number" &&
                typeof v.z === "number" &&
                typeof v.w === "number") {
                out[k] = toThreeQuaternion(v);
            }
            else if (typeof v.x === "number" &&
                typeof v.y === "number" &&
                typeof v.z === "number") {
                out[k] = toThreeVector3(v);
            }
            else {
                out[k] = v;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
exports.transformToThreeObject = transformToThreeObject;
